import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl84 = `${httpUrl.host}/gy-apartment`;
let baseUrl85 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 模板管理——分页
  getTemplatePage: `${baseUrl}/template/getPage`,

  // 模板管理——添加
  addTemplate: `${baseUrl}/template/add`,

  // 模板管理——详情
  getTemplateByCode: `${baseUrl}/template/getByCode`,

  // 模板管理——修改
  updateTemplate: `${baseUrl}/template/update`,

  // 模板管理——删除
  deleteTemplateByCodes: `${baseUrl}/template/deleteByCodes`,

  // 项目管理——分页
  getProjectPage: `${baseUrl}/project/getPage`,

  // 项目管理——添加
  addProject: `${baseUrl}/project/add`,

  // 项目管理——详情
  getProjectByCode: `${baseUrl}/project/getByCode`,

  // 项目管理——修改
  updateProject: `${baseUrl}/project/update`,

  // 项目管理——删除
  deleteProjectByCodes: `${baseUrl}/project/deleteByCodes`,

  //获取模板列表
  getTemplateList: `${baseUrl}/template/getList`,

  //查询住户
  getEnterpriseList: `${baseUrl85}/enterpriseInfo/getEnterpriseList`,

  //查询人员
  getPersonList: `${baseUrl84}/authority/getPersonPage`,

  //项目发布——分页
  getPublishmentPage: `${baseUrl}/publish/getPage`,

  // 项目发布——添加
  addPublishment: `${baseUrl}/publish/add`,

  // 项目发布——删除
  deletePublishmentByCodes: `${baseUrl}/publish/deleteByCodes`,

  //获取项目列表
  getProjectList: `${baseUrl}/project/getList`,

  // 项目发布——修改
  updatePublishment: `${baseUrl}/publish/update`,

  //项目发布——详情
  getPublishmentByCode: `${baseUrl}/publish/getByCode`,

  //获取答案列表
  getAnswerList: `${baseUrl}/publish/getAnswerData`,

  //获取汇总列表
  getQuestionList: `${baseUrl}/publish/getQuestions`,

  //导出答案
  exportAnswerData: `${baseUrl}/publish/exportAnswerData`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/Questionnaire.js